import React, {useEffect, useState} from "react";
import { Database } from "../config/config.js";
import NavBar from "./NavBar";
import { Button } from "@material-ui/core";
import Ingresos from "./Forms/Ingresos";
import Inmobiliario from "./Forms/Inmobiliario";
import Vehiculo from "./Forms/Vehiculo";
import "../Style/FormInputs.css";
import { Alert , AlertTitle } from '@material-ui/lab'

const FormInputs = () => {
  const [sueldoBrutoAnual, setSueldoBrutoAnual] = useState({});
  const [automotorMunicipal, setAutomotorMunicipal] = useState({});
  const [automotorProvincial, setAutomotorProvincial] = useState({});
  const [inmobiliarioProvincial, setInmobiliarioProvincial] = useState([]);
  const [contribucionGasLuz, setContribucionGasLuz] = useState({});
  const [errorflag, setError] = useState(false);

  const handleClick = () => {
      const result = calculator()
    if (isNaN(result.resultadoDias)) {
      setError(true);
    }
    else {
      createNewResult(result)
    }
      
  };

  useEffect(() => {
    return () => {
      setSueldoBrutoAnual({})
      setAutomotorMunicipal({})
      setAutomotorProvincial({})
      setInmobiliarioProvincial([])
      setContribucionGasLuz({})
    }
  }, []);


  const createNewResult = async (result) => {
    await Database.collection('Results').add({
      diasATrabajar: result.resultadoDias,
      impuestosTotales: result.totalInmpuestosAnuales,
    }).then(doc=> {
      window.location.href = `/result/${doc.id}/${result.resultadoDias}`;
    });
  }




const calculator = () => {
const ingresosDiarios = (sueldoBrutoAnual.sueldoBruto + sueldoBrutoAnual.monotributo.Monto + sueldoBrutoAnual.facturacionBruta)/365;
const comercioIndustria = sueldoBrutoAnual.facturacionBruta * (0.7/100)
const ingresosBrutos = sueldoBrutoAnual.facturacionBruta * (4.75/100)
const totalInmpuestoInmobiliario= totalInmpuestosInmobiliario(inmobiliarioProvincial)
const totalInmpuestoAutomotor= totalInmpuestos(automotorProvincial) + totalInmpuestos(automotorMunicipal)
const impuestoMonotributo = (sueldoBrutoAnual.monotributo.p + sueldoBrutoAnual.monotributo.m) * 12 * 1.35
const contribucionGasLuzTotal = totalInmpuestos(contribucionGasLuz)
const totalOtrosImpuestos= (comercioIndustria + ingresosBrutos + totalInmpuestoInmobiliario +totalInmpuestoAutomotor + impuestoMonotributo + contribucionGasLuzTotal) * 0.16/0.86
const totalInmpuestosAnuales= (comercioIndustria + ingresosBrutos + totalInmpuestoInmobiliario +totalInmpuestoAutomotor + impuestoMonotributo + contribucionGasLuzTotal) + totalOtrosImpuestos
const resultadoDias = totalInmpuestosAnuales /ingresosDiarios
return {resultadoDias, totalInmpuestosAnuales}

}



const totalInmpuestosInmobiliario = (array) => {
 const arrayInmobiliarioProvincial = Object.values(array)
 let totalImpuestos = 0
 arrayInmobiliarioProvincial.forEach(element => totalImpuestos += (element + (element*0.8)));
 return totalImpuestos
}

const totalInmpuestos = (array) => {
  const arrayInmobiliarioProvincial = Object.values(array)
  let totalImpuestos = 0
  arrayInmobiliarioProvincial.forEach(element => totalImpuestos += element );
  return totalImpuestos
 }

  return (
    <div className="FormIngresos">
      <NavBar />
      {errorflag &&<Alert severity="error">
  <AlertTitle>Error</AlertTitle>
  Corrobore que todos los campos esten completos. De ser correcto, espere un tiempo e intente nuevamente
  </Alert>}
      <div className="FormIngresos_Ingresos">
        <div className="FormIngresos_Ingreso FormInputs_Ingreso_Vehiculo">
          <Ingresos sueldoBrutoAnual={setSueldoBrutoAnual} />
        <Vehiculo automotorMunicipal={setAutomotorMunicipal} automotorProvincial={setAutomotorProvincial} />
        </div>
        <div className="FormIngresos_Ingreso">
          <Inmobiliario  inmobiliarioProvincial={setInmobiliarioProvincial} contribucionGasLuz={setContribucionGasLuz} />
        </div>
      </div>
      <div className="FormInputs_Actions">
        <Button type='submit' onClick={handleClick} size="large" variant="contained" >
          Calcular
        </Button>
      </div>
    </div>
  );
};

export default FormInputs;
